/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { LoadingMessageMemoized } from '../../../../../components/LoadingMessage'
import styles from './styles.module.css'

export const LoadingLayoutStepFour = ({ onClickCancelArtPending }) => {

  const { t } = useTranslation()

  const messagesArray1 = localStorage.i18nextLng !== 'en' ? [
    'Aguarde um instante. Estamos definindo a linha estratégica dos textos.',
    'Um momento. Os textos estão sendo gerados.',
    'Ótimo! Seus textos já estão prontos. Vamos trabalhar nas cores agora.',
    'Suas cores foram escolhidas. Vamos tratar das imagens.',
    'Excelente! Suas imagens foram tratadas pela nossa IA.',
    'Aguarde mais um instante, estamos diagramando a sua arte.',
    'Certo. Sua arte está diagramada e agora estamos aplicando os efeitos.',
    'Aguarde mais um instante. Sua arte está quase pronta.'
  ] : [
    'Please wait a moment. We’re defining the strategic direction of the texts.',
    'Just a moment. The texts are being generated.',
    'Great! Your texts are ready. Let’s work on the colors now.',
    'Your colors have been selected. Let’s move on to the images.',
    'Excellent! Your images have been processed by our AI.',
    'Please wait a little longer, we’re laying out your design.',
    'Alright. Your design has been laid out and we’re now applying the effects.',
    'Please wait a moment. Your design is almost ready.'
  ]

  const messagesArray2 = localStorage.i18nextLng !== 'en' ? [
    'Postagens e Redes Sociais Frequência ideal no Instagram – Marcas que postam 3 a 5 vezes por semana têm até 30% mais engajamento que as que postam apenas 1 vez por semana.',
    'Stories – Contas que postam diariamente nos Stories geram até 2x mais interações diretas (respostas, cliques).',
    'Reels – Publicar de 4 a 7 Reels por semana pode aumentar o alcance em até 300% em comparação com apenas 1 Reel por semana.',
    'Primeiros 60 minutos – Posts que recebem alto engajamento na primeira hora têm até 2,5x mais chance de serem impulsionados pelo algoritmo.',
    'Melhores horários gerais no Instagram – Terça e quarta entre 10h e 14h, e sexta às 15h, geram picos de alcance e engajamento.',
    'Vídeo x Imagem – Vídeos no Instagram têm, em média, 38% mais alcance que imagens estáticas.',
    'Uso de hashtags – Entre 9 e 11 hashtags relevantes pode aumentar o alcance em até 20% (acima disso, a taxa tende a cair).',
    'Legendas curtas – Posts com legendas de até 150 caracteres têm 17% mais interações que legendas muito longas.'
  ] :
    [
      'Posts and Social Media – Ideal frequency on Instagram: Brands that post 3 to 5 times per week get up to 30% more engagement than those posting only once a week.',
      'Stories – Accounts that post daily on Stories generate up to 2x more direct interactions (replies, clicks).',
      'Reels – Publishing 4 to 7 Reels per week can increase reach by up to 300% compared to posting only 1 Reel per week.',
      'First 60 minutes – Posts that receive high engagement within the first hour are up to 2.5x more likely to be boosted by the algorithm.',
      'Best overall times on Instagram – Tuesday and Wednesday between 10 a.m. and 2 p.m., and Friday at 3 p.m., tend to generate peak reach and engagement.',
      'Video vs. Image – Videos on Instagram have, on average, 38% more reach than static images.',
      'Use of hashtags – Using 9 to 11 relevant hashtags can increase reach by up to 20% (above that, the rate tends to drop).',
      'Short captions – Posts with captions up to 150 characters get 17% more interactions than very long captions.'

    ]

  const ContextField = () => {
    const ConfigArtField = () => {
      const EditArtField = () => {
        const FooterRenderNotEditArt = () => {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row-reverse',
                justifyContent: 'space-between',
                gap: 10,
              }}
            >
              <Skeleton baseColor='#190027' highlightColor='#6904a3ff' borderRadius={100} width={186} height={50} />
              <Skeleton style={{ border: '1px solid #C4C4C4' }} baseColor='#F3F3F3' borderRadius={100} width={130} height={50} />
            </div>
          )
        }

        return (
          <div
            style={{

              display: 'flex',
              flexDirection: 'column',

              border: '1px solid #D9D9D9',

              borderRadius: 15,

              padding: 20,
              overflowY: 'auto',

              gap: 20,
            }}
          >
            <div
              style={{
                width: '100%',

                flex: 1,
                overflowY: 'auto',
              }}
            >
              <label
                style={{
                  fontSize: 14,
                  color: '#686868',
                  fontWeight: 500,
                }}
              >
                {t('new_publication_page_ia_step_fourth_edit_text')}
              </label>
              <div>
                <Skeleton
                  baseColor='#F3F3F3'
                  borderRadius={10}
                  height={36}
                />
              </div>
            </div>
            <FooterRenderNotEditArt />
          </div>
        )
      }

      const EditLegendField = () => {
        return (
          <div
            style={{
              display: 'flex',
              border: '1px solid #D9D9D9',
              borderRadius: 15,
              padding: 20,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                cursor: 'default',
                flex: 1,
              }}
            >
              <div
                className={styles.form_container_input}
                style={{
                  cursor: 'default',
                }}
              >
                <label
                  style={{
                    fontSize: 14,
                    color: '#686868',
                    fontWeight: 500,
                    fontFamily: 'Poppins',
                  }}
                >
                  {t('new_publication_page_ia_step_fourth_legend')}
                </label>

                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px'
                }}>
                  <Skeleton
                    baseColor='#F3F3F3'
                    borderRadius={100}
                    height={36} />
                  <Skeleton
                    baseColor='#F3F3F3'
                    borderRadius={100}
                    height={36} />
                  <Skeleton
                    baseColor='#F3F3F3'
                    borderRadius={100}
                    height={36} />
                  <Skeleton
                    baseColor='#F3F3F3'
                    width={'80%'}
                    borderRadius={100}
                    height={36} />
                </div>
              </div>
            </div>
          </div>
        )
      }

      return (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              flex: 1,
            }}
          >
            <EditArtField />
            <EditLegendField />
          </div>
        </>
      )
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          maxHeight: 'calc(100% - 50px)',
          flex: 1
        }}
      >
        {/* <div className={styles.title_new_posts}>
          <p className={styles.title_new_posts_label}>{t('new_publication_page_ia_step_fourth_header_new')} </p>
          <p className={styles.title_new_posts_title}>{t('new_publication_page_ia_step_fourth_header_publication')}</p>
        </div> */}

        <div
          className={styles.container_content}
        >
          <div className={styles.container_image_example}>
            <div className={styles.image_container}>
              <div className={styles.box_image}>
                {<LoadingMessageMemoized
                  messagesArray1={messagesArray1}
                  messagesArray2={messagesArray2}
                  messagesTime={8000} />}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 10,
                }}
              >
                <Skeleton baseColor='#F3F3F3' style={{ border: '1px solid #C4C4C4' }} height={50} width={410} borderRadius={100} />
              </div>
            </div>
            <ConfigArtField />
          </div>
        </div>
      </div>
    )
  }

  const FooterField = () => {
    return (
      <>
        <div className={styles.button_nav}>
          <button
            className={styles.button_back}
            onClick={onClickCancelArtPending}
          >
            <p className={styles.button_title}>{t('back_buttom')}</p>
          </button>

          <div
            style={{
              display: 'flex',
              gap: '10px',
              pasition: 'fixed',
              marginRight: 20,
            }}
          >
            <button
              className={styles.button_next}
            >
              <p className={styles.button_title}>
                {t('new_publication_page_fourth_pass_finish_scheduling')}
              </p>
            </button>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className={styles.container_page}>
      <ContextField />
      <FooterField />
    </div>
  )
}


export const LoadingLayoutMemoized = React.memo(LoadingLayoutStepFour, () => true)


